import {
  EXCHANGE_FEEDBACK_ACTION,
  EXCHANGE_PARTNER_ACTION,
  EXCHANGE_SETTINGS_ACTION,
  EXCHANGE_CONFIG_ACTION
} from '../../constants/actions'

// EXCHANGE SETTINGS
const changeExchangeSettingsState = (property, value) => {
  return {
    type: EXCHANGE_SETTINGS_ACTION.CHANGE_STATE,
    payload: {
      property,
      value
    }
  }
}

const saveExchangeSettings = () => {
  return {
    type: EXCHANGE_SETTINGS_ACTION.ON_SAVE_SETTINGS
  }
}

// PARTNERS
const changePartnersState = (tab, property, value) => {
  return {
    type: EXCHANGE_PARTNER_ACTION.CHANGE_STATE,
    payload: { tab, property, value }
  }
}

const resetExchangeFilters = () => {
  return {
    type: EXCHANGE_PARTNER_ACTION.ON_RESET_FILTERS
  }
}

const getPotentialPartners = () => {
  return {
    type: EXCHANGE_PARTNER_ACTION.ON_GET_PARTNERS
  }
}

const connectExchangePartner = (toTokenId) => {
  return {
    type: EXCHANGE_PARTNER_ACTION.ON_CONNECT_EXCHANGE,
    payload: { toTokenId }
  }
}

const updateExchangeConnection = (action, data, connection) => {
  return {
    type: EXCHANGE_PARTNER_ACTION.ON_UPDATE_EXCHANGE_CONNECTION,
    payload: { action, data, connection }
  }
}

const changeExchangeFeedback = (property, value) => {
  return {
    type: EXCHANGE_FEEDBACK_ACTION.CHANGE_STATE,
    payload: {
      property,
      value
    }
  }
}

const resetExchangeFeedback = () => {
  return {
    type: EXCHANGE_FEEDBACK_ACTION.ON_RESET_STATE
  }
}

const changeExchangeConfig = (property, value) => {
  return {
    type: EXCHANGE_CONFIG_ACTION.CHANGE_STATE,
    payload: {
      property,
      value
    }
  }
}

const resetExchangeConfig = () => {
  return {
    type: EXCHANGE_CONFIG_ACTION.ON_RESET_STATE
  }
}

export {
  changeExchangeSettingsState,
  saveExchangeSettings,
  getPotentialPartners,
  connectExchangePartner,
  changePartnersState,
  updateExchangeConnection,
  changeExchangeFeedback,
  resetExchangeFeedback,
  changeExchangeConfig,
  resetExchangeConfig,
  resetExchangeFilters
}
